const words = {
  ERROR: {
    ar: "تم حدوث خطأ!",
    en: "An Error Occurred!",
    tu: "Giriş Yap",
    ru: "Войти",
    fr: "S'identifier",
  },
  SAVE: {
    ar: 'حفظ',
    en: 'Save',
    tu: "Giriş Yap",
    ru: "Войти",
    fr: "S'identifier",
  },
  YOUR_MESSAGE_HAS_BEEN_SENT_SUCCESSFULLY: {
    en: "Your message has been sent successfully",
    ar: "تم ارسال الرساله بنجاح",
    fr: "Nos fonctionnalités",
    tu: "Özelliklerimiz",
    ru: "Наши особенности",
  },
  SAVE_CHANGES: {
    en: 'Do you want to cancel editing?',
    ar: 'هل تريد الغاء التعديل؟',
    tu: "",
    ru: "",
    fr: "",
  },
  HELP: {
    en: 'Open Ticket',
    ar: 'أرسل شكوى',
    tu: "",
    ru: "",
    fr: "",
  },
  CHOOSE_PROBLEM: {
    en: 'Choose problem',
    ar: 'أختر مشكله ',
    tu: "",
    ru: "",
    fr: ""
  },
  PRIVACY_CARD: {
    en: 'Privacy card',
    ar: 'بطاقة الخصوصية',
    tu: "",
    ru: "",
    fr: "",
  },
  DO_YOU_WANT_TO_DISCARD_YOUR_CHAGES: {
    en: "Do you want to discard your changes?",
    ar: "هل تريد التخلص من التغييرات الخاصة بك؟",
    tu: "",
    ru: "",
    fr: "",
  },
  YOUR_CARD_DESIGN_HAS_BEEN_SENT_SUCCESSFULLY: {
    en: "Your Card design has been Sent successfully",
    ar: " تم ارسال تصميم البطاقة بنجاح",
    tu: "",
    ru: "",
    fr: "",
  },
  WE_WILL_RESPONSE_YOU_WITHIN_TWO_DAYS_WORKING_HOURS: {
    en: "We will response you within 2 days working hours",
    ar: "سوف نرد عليك في غضون ساعات العمل لمدة يومين",
    tu: "",
    ru: "",
    fr: "",
  },
  CANCEL: {
    ar: 'الغاء',
    en: 'Cancel',
    tu: "",
    ru: "",
    fr: "",
  },
  CANCEL_EDIT: {
    ar: ' الغاءالتحديث',
    en: 'Cancel Changes',
    tu: "",
    ru: "",
    fr: "",
  },
  UPLOAD_ERROR: {
    ar: 'حفظ',
    en: 'Couldn\'t Upload Excel sheet please try again',
    tu: "Giriş Yap",
    ru: "Войти",
    fr: "S'identifier",
  },
  BUSINESS_CARD: {
    ar: 'بطاقة اعمال',
    en: 'Business card',
    tu: "Giriş Yap",
    ru: "Войти",
    fr: "S'identifier",
  },

  MORE_COHERENT: {
    ar: 'شبكة أكثر تماسكًا مع بطاقة الأعمال الرقمية Swipy. الآن يمكنك إنشاء بطاقات متعددة اللغات.',
    en: 'More Coherent networking with Swipy digital ',
    tu: "",
    ru: "",
    fr: "",
  },
  MORE_COHERENT2: {
    ar: '',
    en: 'business card.',
    tu: "",
    ru: "",
    fr: "",
  },
  MORE_COHERENT3: {
    ar: "",
    en: 'Now you could create multilinguistic cards.',
    tu: "",
    ru: "",
    fr: "",
  },
  LANGUAGE: {
    ar: 'اللغة',
    en: 'Language',
    tu: "",
    ru: "",
    fr: "",
  },
  ARABIC: {
    ar: 'العربية',
    en: 'Arabic',
    tu: "",
    ru: "",
    fr: "",
  },
  ENGLISH: {
    ar: 'الانجليزية',
    en: 'English',
    tu: "",
    ru: "",
    fr: "",
  },
  SELECT_LANGUAGE: {
    en: "Select Language",
    ar: "اختار اللغة",
    tu: "",
    ru: "",
    fr: "",
  },
  LOADING: {
    ar: 'حفظ',
    en: 'Loading',
    tu: "Giriş Yap",
    ru: "Войти",
    fr: "S'identifier",
  },
  NO_MORE_OPTIONS: {
    ar: 'حفظ',
    en: 'No more options',
    tu: "Giriş Yap",
    ru: "Войти",
    fr: "S'identifier",
  },
  CHANGE_YOUR_EMAIL: {
    ar: 'تغيير البريد الألكتروني',
    en: 'Change your Email',
    tu: "Giriş Yap",
    ru: "Войти",
    fr: "S'identifier",
  },
  CHANGE_YOUR_PASSWORD: {
    ar: 'تغيير كلمه المرور ',
    en: 'Change your password',
    tu: "Giriş Yap",
    ru: "Войти",
    fr: "S'identifier",
  },
  CHOOSE_YOUR_PLAN: {
    en: "Choose your plan",
    ar: "اختر خطتك",
    tu: "Planınızı seçin",
    ru: "Выберите свой план",
    fr: "Choisissez votre forfait"
  },
  YOUR_PASS_CHANGED: {
    ar: 'تم تغيير كلمة السر بنجاح',
    en: 'Your Password Changed Successfully',
    tu: "",
    ru: "",
    fr: "",
  },
  NEXT: {
    ar: 'التالي',
    en: 'Next',
    tu: "Giriş Yap",
    ru: "Войти",
    fr: "S'identifier",
  },
  WEBSITE: {
    ar: 'الموقع',
    en: 'Website',
    tu: "Giriş Yap",
    ru: "Войти",
    fr: "S'identifier",
  },
  DONE: {
    ar: 'تم',
    en: 'Done',
    tu: "",
    ru: "",
    fr: "",
  },
  PRIVACY_CONTENT: {
    en: "Your business card's QR code will not be visible or accessible to anyone else unless you choose to share it. It serves as a notice to remind you that your card information is safeguarded and can only be shared at your discretion.",
    ar: "لن يكون رمز الاستجابة السريعة الخاص ببطاقة عملك مرئيًا أو يمكن لأي شخص آخر الوصول إليه إلا إذا اخترت مشاركته. إنه بمثابة إشعار لتذكيرك بأن معلومات بطاقتك محمية ولا يمكن مشاركتها إلا وفقًا لتقديرك.",
    tu: "Kartvizitinizin QR kodu, siz paylaşmayı seçmediğiniz sürece başkaları tarafından görülmeyecek veya erişilebilir olmayacaktır. Kart bilgilerinizin korunduğunu ve yalnızca sizin takdirinize bağlı olarak paylaşılabileceğini size hatırlatmak için bir bildirim görevi görür.",
    ru: "QR-код вашей визитной карточки не будет виден или доступен кому-либо еще, если вы не решите поделиться им. Оно служит напоминанием о том, что данные вашей карты защищены и могут быть переданы только по вашему усмотрению.",
    fr: "Le code QR de votre carte de visite ne sera ni visible ni accessible à quiconque, sauf si vous choisissez de le partager. Il sert d'avis pour vous rappeler que les informations de votre carte sont protégées et ne peuvent être partagées qu'à votre discrétion."
  },
  GO_TO_BILLING: {
    ar: 'الذهاب الى الفواتير',
    en: 'Go to Billing',
    tu: "",
    ru: "",
    fr: "",
  },
  CONTACT_US: {
    ar: 'تواصل معنا',
    en: 'Contact Us',
    tu: "",
    ru: "",
    fr: "",
  },
  CARDLINK: {
    ar: 'رابط البطاقة',
    en: 'Card Link',
    tu: "",
    ru: "",
    fr: "",
  },
  CARD: {
    ar: 'بطاقة',
    en: 'Card',
    tu: "",
    ru: "",
    fr: "",
  },
  COLORS: {
    ar: 'الالوان',
    en: 'Colors',
    tu: "",
    ru: "",
    fr: "",
  },
  COLOR: {
    ar: 'لون',
    en: 'Color',
    tu: "",
    ru: "",
    fr: "",
  },
  QR: {
    en: "QR",
    ar: "QR",
    tu: "",
    ru: "",
    fr: "",
  },
  FONT: {
    ar: 'الخط',
    en: 'Font',
    tu: "",
    ru: "",
    fr: "",
  },
  RESET: {
    ar: 'اعادة تعيين',
    en: 'Reset',
    tu: "",
    ru: "",
    fr: "",
  },
  UPGRADE_NOW: {
    ar: 'ترقية الان',
    en: 'Upgrade Now',
    tu: "",
    ru: "",
    fr: "",
  },
  UPGRADE_SUBSCRIPTION: {
    ar: "تحديث الاشتراك",
    en: "Upgrade Subscription",
    tu: "",
    ru: "",
    fr: "",
  },
  UPDATE_PAYMENT_DETTAILS: {
    ar: "تحديث تفاصيل الدفع",
    en: "Update Payment Details",
    tu: "",
    ru: "",
    fr: "",
  },
  YOUR_CARD: {
    ar: 'بطاقتك',
    en: 'Your Card',
    tu: "",
    ru: "",
    fr: "",
  },
  USER_CARD: {
    ar: 'بطاقة المستخدم',
    en: 'User Card',
    tu: "",
    ru: "",
    fr: "",
  },
  MY_CARD: {
    ar: 'بطاقتي',
    en: 'My Card',
    tu: "",
    ru: "",
    fr: "",
  },
  ERROR_MESSAGE: {
    ar: "برجاء التواصل بإدارة أدميكس",
    en: "Please Contact Addmix System Support",
    tu: "Giriş Yap",
    ru: "Войти",
    fr: "S'identifier",
  },
  MESSAGE: {
    ar: " الرساله ",
    en: "Message",
    tu: "Giriş Yap",
    ru: "Войти",
    fr: "S'identifier",
  },
  ENTER_VERIFICATION_CODE: {
    ar: "برجاء ادخال كود التفعيل",
    en: "Please enter the verification code we just sent",
    tu: "Giriş Yap",
    ru: "Войти",
    fr: "S'identifier",
  },
  VERIFICATION_CODE: {
    ar: "برجاء ادخال كود التفعيل",
    en: "Verification code",
    tu: "Giriş Yap",
    ru: "Войти",
    fr: "S'identifier",
  },
  MAKE_SURE_YOU_ENTERED_CORRECT_EMAIL: {
    ar: "برجاء ادخال كود التفعيل",
    en: "Please make sure you entered your email correctly",
    tu: "Giriş Yap",
    ru: "Войти",
    fr: "S'identifier",
  },
  TO_YOUR_EMAIL: {
    ar: "برجاء ادخال كود التفعيل",
    en: "to your Email.",
    tu: "Giriş Yap",
    ru: "Войти",
    fr: "S'identifier",
  },
  YOUR_INFO: {
    ar: "بياناتك",
    en: "Your Info",
    tu: "Giriş Yap",
    ru: "Войти",
    fr: "S'identifier",
  },
  ORGANIZATION_INFO: {
    ar: "",
    en: "Organization Info",
    tu: "Giriş Yap",
    ru: "Войти",
    fr: "S'identifier",
  },
  PLEASE_MAKE_SURE: {
    ar: "تأكد منادخالك للبريد الألكتروني الصحيح",
    en: "Please make sure you entered your email correctly",
    tu: "Giriş Yap",
    ru: "Войти",
    fr: "S'identifier",
  },
  FULL_NAME: {
    ar: "الأسم بالكامل",
    en: "Full Name",
    tu: "Ad Soyad",
    ru: "Полное имя",
    fr: "Nom et prénom",
  },
  EMAIL: {
    ar: "البريد الألكتروني",
    en: "Email",
    tu: "Giriş Yap",
    ru: "Войти",
    fr: "S'identifier",
  },
  PRIVACY: {
    ar: "الخصوصية",
    en: "Privacy",
    tu: "Giriş Yap",
    ru: "Войти",
    fr: "S'identifier",
  },
  PUBLIC: {
    ar: "عام",
    en: "Public",
    tu: "Giriş Yap",
    ru: "Войти",
    fr: "S'identifier",
  },
  VIEW_CARD: {
    ar: "",
    en: "View Card",
    tu: "",
    ru: "",
    fr: ""
  },
  WELCOME_TO: {
    ar: "مرحبا بك في",
    en: "Welcome to",
    tu: "Giriş Yap",
    ru: "Войти",
    fr: "S'identifier",
  },
  PASSWORD: {
    ar: "كلمه المرور",
    en: "password",
    tu: "Giriş Yap",
    ru: "Войти",
    fr: "S'identifier",
  },
  CURRENT_PASSWORD: {
    ar: "كلمه المرور",
    en: "Current password",
    tu: "Giriş Yap",
    ru: "Войти",
    fr: "S'identifier",
  },
  NEW_PASSWORD: {
    ar: "كلمه المرور",
    en: "New password",
    tu: "Giriş Yap",
    ru: "Войти",
    fr: "S'identifier",
  },
  LOG_IN: {
    ar: "تسجيل الدخول",
    en: "Login",
    tu: "Giriş Yap",
    ru: "Войти",
    fr: "S'identifier",
  },
  SIGN_UP: {
    en: "Sign up",
    ar: "تسجيل",
    tu: "Kayıt Ol",
    ru: "Зарегистрироваться",
    fr: "S'inscrire",
  },
  DO_NOT_HAVE_AN_ACCOUNT: {
    ar: "ليس لديك حساب",
    en: "Don't have an account?",
    tu: "Giriş Yap",
    ru: "Войти",
    fr: "S'identifier",
  },
  EDIT_CARD: {
    ar: "تعديل البطاقة",
    en: "Edit Card",
    tu: "Şifremi Unuttum ?",
    ru: "Забыли пароль ?",
    fr: "Mot de passe oublié ?",
  },
  EDIT_YOUR_INFO: {
    ar: "تعديل بيانات",
    en: "Edit Your Info ",
    tu: "Şifremi Unuttum ?",
    ru: "Забыли пароль ?",
    fr: "Mot de passe oublié ?",
  },
  FORGET_PASSWORD: {
    ar: "نسيت كلمة المرور ؟",
    en: "Forgot Password ?",
    tu: "Şifremi Unuttum ?",
    ru: "Забыли пароль ?",
    fr: "Mot de passe oublié ?",
  },
  MINIMUM_8_CHARACTERS: {
    ar: "الحد الأدنى 8 أحرف",
    en: "Minimum 8 characters",
    tu: "Devam et",
    ru: "Продолжить",
    fr: "Continuer",
  },
  CONTINUE_LATER: {
    ar: "اكمل لاحقا",
    en: "Continue Later",
    tu: "",
    ru: "",
    fr: "",
  },
  AT_LEAST_1_LOWERCASE: {
    ar: "حرف صغير واحد على الأقل (a-z)",
    en: "Has At Least 1 Lowercase Character (a-z)",
    tu: "Devam et",
    ru: "Продолжить",
    fr: "Continuer",
  },
  GET_IN_TOUCH_DESC: {
    ar: "حرف صغير واحد على الأقل (a-z)",
    en: "Get In touch",
    tu: "Devam et",
    ru: "Продолжить",
    fr: "Continuer",
  },
  AT_LEAST_1_UPPERCASE: {
    ar: "حرف كبير واحد على الأقل (a-z)",
    en: "Has At Least 1 Uppercase Character (a-z)",
    tu: "Devam et",
    ru: "Продолжить",
    fr: "Continuer",
  },
  AT_LEAST_1_NUMBER: {
    ar: "رقم واحد على الأقل (0-9)",
    en: "Has At Least 1 Number (0-9)",
    tu: "Devam et",
    ru: "Продолжить",
    fr: "Continuer",
  },
  MATCH_PASSWORDS: {
    ar: "",
    en: "Passwords are not Match",
    tu: "",
    ru: "",
    fr: "",
  },
  PASSWORDS_DO_NOT_MATCH: {
    ar: "كلمات المرور غير متطابقة",
    en: "The passwords do not match",
    tu: "Devam et",
    ru: "Продолжить",
    fr: "Continuer",
  },
  PASSWORD: {
    en: " Password",
    ar: " كلمة المرور",
    tu: "Şifreyi Onayla",
    ru: "Подтвердите Пароль",
    fr: "Confirmer le mot de passe",
  },
  CONFIRM_PASSWORD: {
    en: "Confirm Password",
    ar: "تأكيد كلمة المرور",
    tu: "Şifreyi Onayla",
    ru: "Подтвердите Пароль",
    fr: "Confirmer le mot de passe",
  },
  ORGANIZATION_NAME: {
    ar: "كلمه المرور",
    en: "Organization Name",
    tu: "Giriş Yap",
    ru: "Войти",
    fr: "S'identifier",
  },
  INDUSTRY: {
    ar: "كلمه المرور",
    en: "Industry",
    tu: "Giriş Yap",
    ru: "Войти",
    fr: "S'identifier",
  },
  JOB_TITLE: {
    ar: "الوظيفه",
    en: "Job title",
    tu: "Giriş Yap",
    ru: "Войти",
    fr: "S'identifier",
  },
  TITLE: {
    ar: "لقب المهنة",
    en: "Title",
    tu: "Başlık",
    ru: "Заголовок",
    fr: "Titre",
  },
  SWIPY: {
    ar: "Swipy",
    en: "Swipy",
    tu: "Giriş Yap",
    ru: "Войти",
    fr: "S'identifier",
  },
  SWIPY_DESC: {
    ar: " اكتشف نهجًا جديدًا ومبتكرًا للتفاعلات الرقمية، وتبسيط مشاركة المعلومات وتعزيز الاتصالات الهادفة، كل ذلك مع إعطاء الأولوية لرفاهية كوكبنا. ",
    en: "Discover a fresh and innovative approach to digital interactions, simplifying information sharing and fostering meaningful connections, all while prioritizing the well-being of our planet.",
    tu: "",
    ru: "",
    fr: "",
  },
  CARD_DESIGN: {
    ar: "تصميم البطاقة",
    en: "Card Design",
    tu: "",
    ru: "",
    fr: "",
  },
  SIGN_IN: {
    ar: "تسجيل الدخول",
    en: "Sign In",
    tu: "",
    ru: "",
    fr: "",
  },
  USERS: {
    ar: "المستخدمين",
    en: "Users",
    tu: "",
    ru: "",
    fr: "",
  },
  USER: {
    ar: "مستخدم",
    en: "User",
    tu: "",
    ru: "",
    fr: "",
  },
  TO_EMPLOYEE: {
    ar: " إلي الموظفين",
    en: "to Employees",
    tu: "",
    ru: "",
    fr: "",
  },
  FILE_CSV: {
    ar: "ورقة إكسيل",
    en: "File.csv",
    tu: "",
    ru: "",
    fr: "",
  },
  EMPLOYEES: {
    ar: "الموظفين",
    en: "Employees",
    tu: "",
    ru: "",
    fr: "",
  },
  INVOICES: {
    ar: "الفواتير",
    en: "Invoices",
    tu: "",
    ru: "",
    fr: "",
  },
  EMPLOYEES_PERMISSIONS: {
    ar: "يمكن للموظف تعديل رقم هاتفه",
    en: "Employee can edit his/her phone number",
    tu: "",
    ru: "",
    fr: "",
  },
  EMPLOYEES_PERMISSIONS_TOOLTIP: {
    ar: "يمكن للموظف تعديل رقم هاتفه او الواتساب او التيلجرام او السناب شات",
    en: "Employee can edit his/her phone number, whatsapp, telegram and snapchat",
    tu: "",
    ru: "",
    fr: "",
  },
  ALL_CONTANTS_WILL_EXPORT_TO_ANOTHER_EMPLOYEE: {
    ar: "جميع جهات الاتصال سوف تصدر إلى موظف آخر",
    en: "All Contacts will export to another Employee",
    tu: "",
    ru: "",
    fr: "",
  },
  ALL_CONTANTS_WILL_EXPORT_IN_FILE: {
    ar: "جميع جهات الإتصال سوف تصدر في ملف",
    en: "All Contacts will export in File",
    tu: "",
    ru: "",
    fr: "",
  },
  EXPORT_DONE_SUCCESSFULLY: {
    en: "Export Done Successfully",
    ar: " تم التصدير بنجاح",
    tu: "",
    ru: "",
    fr: "",
  },
  USER_NETWORK: {
    en: "User Network",
    ar: "شبكة المستخدم",
    tu: "",
    ru: "",
    fr: "",
  },
  UPLOADING_EXCEL_FILE: {
    ar: "",
    en: "Uploading Excel File",
    tu: "",
    ru: "",
    fr: "",
  },
  ERROR_MODAL_INFO: {
    ar: "",
    en: "salma testing",
    tu: "",
    ru: "",
    fr: "",
  },
  SUCCESS: {
    ar: "",
    en: "Success",
    tu: "",
    ru: "",
    fr: "",
  },
  PROFILE: {
    ar: 'الصفحه الشخصيه',
    en: 'Profile',
    tu: "Giriş Yap",
    ru: "Войти",
    fr: "S'identifier",
  },
  HAVE_ACCOUNT: {
    ar: "",
    en: "Do you have an account? ",
    tu: "",
    ru: "",
    fr: "",
  },
  BILLING: {
    ar: "",
    en: "Billing",
    tu: "",
    ru: "",
    fr: "",
  },
  PLANS_DESC: {
    ar: "",
    en: "We have powerful plans to Showcase your business and get discovered as a creative entrepreneurs. Every thing you need.",
    tu: "",
    ru: "",
    fr: "",
  },
  PLAN_TYPE: {
    ar: "",
    en: "Standard",
    tu: "",
    ru: "",
    fr: "",
  },
  PLAN_TYPE_STANDARD: {
    ar: "",
    en: "Standard",
    tu: "",
    ru: "",
    fr: "",
  },
  PLAN_ONE_USERS: {
    ar: "",
    en: "per user",
    tu: "",
    ru: "",
    fr: "",
  },
  PLAN_ONE_PROS1: {
    ar: "",
    en: "Everything in Solo",
    tu: "",
    ru: "",
    fr: "",
  },
  PLAN_ONE_PROS2: {
    ar: "",
    en: "Bulk Creation",
    tu: "",
    ru: "",
    fr: "",
  },
  PLAN_ONE_PROS3: {
    ar: "",
    en: "Template Management",
    tu: "",
    ru: "",
    fr: "",
  },
  PLAN_ONE_PROS4: {
    ar: "",
    en: "Everything in Team",
    tu: "",
    ru: "",
    fr: "",
  },
  PLAN_ONE_PROS5: {
    ar: "",
    en: "Integrations (e.g. Active Directory)",
    tu: "",
    ru: "",
    fr: "",
  },
  PLAN_ONE_PROS6: {
    ar: "",
    en: "Template Enforcement",
    tu: "",
    ru: "",
    fr: "",
  },
  PLAN_ONE_SUBSCRIBE: {
    ar: "انضمام",
    en: "Subscribe",
    tu: "",
    ru: "",
    fr: "",
  },
  SUBSCRIBE_FOR_STANDAED_PLAN: {
    ar: "إشترك الآن",
    en: "Subscribe For Standard Plan",
    tu: "",
    ru: "",
    fr: "",
  },
  UPDATE_PAYMENT_INFO: {
    ar: "",
    en: "Update Payment Method",
    tu: "",
    ru: "",
    fr: ""
  },
  PLAN_ONE_FREE_TRIAL: {
    ar: "شهر محاني",
    en: "6 Month Free Trial",
    tu: "",
    ru: "",
    fr: "",
  },
  PLAN_ONE_STARTED_FREE_TRIAL: {
    ar: "تواصل معنا",
    en: "You have started 6 month free trail",
    tu: "",
    ru: "",
    fr: "",
  },
  PLAN_TYPE_PLUS: {
    ar: "مميز",
    en: "Plus",
    tu: "",
    ru: "",
    fr: "",
  },
  PLAN_TWO_USERS: {
    ar: "تحدث مع مسئولي المبيعات",
    en: "Talk to Sales",
    tu: "",
    ru: "",
    fr: "",
  },
  PLAN_TWO_CONTACT_US: {
    ar: "تواصل معنا",
    en: "Contact Us",
    tu: "",
    ru: "",
    fr: "",
  },
  ORGANIZATION: {
    ar: "",
    en: "Organization",
    tu: "",
    ru: "",
    fr: "",
  },
  MY_ORGANIZATION: {
    ar: "",
    en: "My Organization",
    tu: "",
    ru: "",
    fr: "",
  },
  CHANGE_YOUR_ORGANIZATION: {
    ar: "",
    en: "Edit Organization Info",
    tu: "",
    ru: "",
    fr: "",
  },
  ORGANIZATION_NAME: {
    ar: "",
    en: "Organization Name",
    tu: "",
    ru: "",
    fr: "",
  },
  ORGANIZATION_SIZE: {
    ar: "",
    en: "Company Size",
    tu: "",
    ru: "",
    fr: "",
  },

  ORGANIZATION_INDUSTRY: {
    ar: "",
    en: "Industry",
    tu: "",
    ru: "",
    fr: "",
  },
  BACKGROUND_COLOR: {
    ar: "",
    en: "Background Color",
    tu: "",
    ru: "",
    fr: ""
  },
  PRIMARY_COLOR: {
    ar: "",
    en: "Primary Color",
    tu: "",
    ru: "",
    fr: "",
  },
  SECONDARY_COLOR: {
    ar: "",
    en: "Secondary Color",
    tu: "",
    ru: "",
    fr: "",
  },
  QR_COLOR: {
    ar: "",
    en: "Qr Color",
    tu: "",
    ru: "",
    fr: "",
  },
  QR_CODE_LAYOUT: {
    ar: "",
    en: "Qr Code Layout",
    tu: "",
    ru: "",
    fr: "",
  },
  FONT_COLOR: {
    ar: "",
    en: "Font Color",
    tu: "",
    ru: "",
    fr: "",
  },

  AUTOMATICALLY_USE_YOUR_LOGO: {
    ar: "",
    en: "Automatically use your logo",
    tu: "",
    ru: "",
    fr: "",
  },
  AUTOMATICALLY_USE_YOUR_FONT_COLOR: {
    ar: "",
    en: "Automatically use your font color",
    tu: "",
    ru: "",
    fr: "",
  },



  MENU: {
    ar: "",
    en: "Menu",
    tu: "",
    ru: "",
    fr: "",
  },
  LOG_OUT: {
    ar: "تسجيل الخروج",
    en: "Log Out",
    tu: "Çıkış Yap",
    ru: "Выйти",
    fr: "Se déconnecter",
  },
  MY_PROFILE: {
    en: "My Profile",
    ar: "ملفي الشخصي",
    tu: "Profilim",
    ru: "Мой профиль",
    fr: "Mon profil",
  },
  HELP_CENTER: {
    en: "Help Center",
    ar: "مركز الخدمه",
    tu: "Profilim",
    ru: "Мой профиль",
    fr: "Mon profil",
  },
  ACTIVE: {
    en: "Active ",
    ar: " نشط",
    tu: "Promosyon kodları",
    ru: "Промокоды",
    fr: "Code de promo"
  },
  USED: {
    en: "Used ",
    ar: " مستخدم",
    tu: "Promosyon kodları",
    ru: "Промокоды",
    fr: "Code de promo"
  },
  PROMO_CODES: {
    en: "Promo Codes",
    ar: "الرموز الترويجية",
    tu: "Promosyon kodları",
    ru: "Промокоды",
    fr: "Code de promo"
  },
  PROMO_CODE: {
    en: "Promo Code",
    ar: "الرمز الترويجي",
    tu: "Promosyon kodları",
    ru: "Промокоды",
    fr: "Code de promo"
  },
  HAVE_PROMO_CODE: {
    en: "Have Promo code ?",
    ar: "لديك رمز ترويجي",
    tu: "Promosyon kodları",
    ru: "Промокоды",
    fr: "Code de promo"
  },
  REDEEM_YOUR_PROMO_AND_ENJOY_WITH_THE_DISCOUND: {
    en: "Redeem your promo and enjoy with the discount",
    ar: "استبدل العرض الترويجي الخاص بك واستمتع بالخصم ",
    tu: "Promosyon kodları",
    ru: "Промокоды",
    fr: "Code de promo"
  },
  REDEEM_YOUR_PROMO: {
    en: "Redeem Your Promo Code",
    ar: "استبدل العرض الترويجي الخاص بك ",
    tu: "Promosyon kodları",
    ru: "Промокоды",
    fr: "Code de promo"
  },
  REDEEM_YOUR_PROMO_AND_ENJOY_WITH_THE_DISCOUND_IN_PRO_VERSION: {
    en: "Redeem your promo to enjoy discount in pro version.",
    ar: "استرد العرض الترويجي الخاص بك للاستمتاع بالخصم في الإصدار المحترف",
    tu: "Promosyon kodları",
    ru: "Промокоды",
    fr: "Code de promo"
  },
  REDEEM: {
    en: "Redeem",
    ar: "استرد",
    tu: "Promosyon kodları",
    ru: "Промокоды",
    fr: "Code de promo"
  },
  CONTINUE: {
    en: "Continue ",
    ar: "إستمر",
    tu: "Promosyon kodları",
    ru: "Промокоды",
    fr: "Code de promo"
  },
  APPLY: {
    en: "Apply",
    ar: "تابع",
    tu: "",
    ru: "",
    fr: ""
  },
  MY_CARD: {
    en: "My Card",
    ar: "بطاقتي",
    tu: "Kartım",
    ru: "Моя карта",
    fr: "Ma carte",
  },
  BILLING: {
    en: "Billing",
    ar: "الفواتير",
    tu: "Faturalandırma",
    ru: "Выставление счетов",
    fr: "Facturation",
  },
  NOT_IN_FREE_TRIAL: {
    en: "You are in a free trial until",
    ar: "أنت في فترة تجريبية مجانية حتى",
    tu: "",
    ru: "",
    fr: ""
  },
  NOT_SUBSCRIBE: {
    en: "You're not subscribed",
    ar: "أنت غير مشترك",
    tu: "",
    ru: "",
    fr: ""
  },
  NO_USERS_FOUND: {
    en: "Your contacts list is empty. Please either upload the Excel sheet to export your contacts, or alternatively, enter them manually.",
    ar: "ليس لديك اتصالات ، حاول جعلهم يشاركون بطاقات عملهم معك",
    tu: "",
    ru: "",
    fr: "",
  },
  NO_CARDS_FOUND: {
    en: "You don’t have business card add one",
    ar: "ليس لديك بطاقة عمل أضف واحدة",
    tu: "",
    ru: "",
    fr: "",
  },
  NO_PROMO_CODES_FOUND: {
    en: "No Promo codes found",
    ar: "لم يتم العثور على رموز ترويجية",
    tu: "",
    ru: "",
    fr: "",
  },
  DOWNLOAD_INVOICE: {
    en: "Download Invoice",
    ar: "",
    tu: "",
    ru: "",
    fr: "",
  },
  UPLOAD_EXCEL_SHEET: {
    en: "Upload Excel Sheet",
    ar: "تحميل ورقة Excel",
    tu: "",
    ru: "",
    fr: "",
  },
  UPLOAD_YOUR_DESIGN: {
    en: "Upload Your Design",
    ar: "قم بتحميل التصميم الخاص بك",
    tu: "",
    ru: "",
    fr: "",
  },
  DOWNLOAD_TEMPLETE: {
    en: "Download Template",
    ar: "تحميل القالب",
    tu: "",
    ru: "",
    fr: "",
  },
  NO_USERS: {
    en: "No Users",
    ar: "لا يوجد مستخدمين",
    tu: "",
    ru: "",
    fr: "",
  },
  LAST_EDIT: {
    en: "Last Edit",
    ar: "اخر تعديل",
    tu: "",
    ru: "",
    fr: "",
  },
  NAME: {
    en: "Name",
    ar: "الاسم",
    tu: "",
    ru: "",
    fr: "",
  },
  NAME_LANG1: {
    en: "Name Language 1",
    ar: "الاسم",
    tu: "",
    ru: "",
    fr: "",
  },
  NAME_LANG2: {
    en: "Name Language 2",
    ar: "الاسم",
    tu: "",
    ru: "",
    fr: "",
  },
  PHONE_NUMBER: {
    en: "Phone Number",
    ar: "رقم الهاتف",
    tu: "",
    ru: "",
    fr: "",
  },
  NO_CARDS: {
    en: "No.cards",
    ar: "رقم الكروت",
    tu: "",
    ru: "",
    fr: "",
  },
  ACTIONS: {
    en: "Actions",
    ar: "الإجراءات",
    tu: "",
    ru: "",
    fr: "",
  },
  DISPLAYED: {
    en: "Displayed",
    ar: "معروض",
    tu: "Sonraki",
    ru: "Далее",
    fr: "Suivant",
  },
  ROWS_PER_PAGE: {
    en: "Rows per page",
    ar: "صفوف في الصفحة",
    tu: "Sonraki",
    ru: "Далее",
    fr: "Suivant",
  },
  OUT_OF: {
    en: "Out Of",
    ar: "من",
    tu: "Sonraki",
    ru: "Далее",
    fr: "Suivant",
  },
  NEXT: {
    en: "Next",
    ar: "التالي",
    tu: "Sonraki",
    ru: "Далее",
    fr: "Suivant",
  },
  PREVIOUS: {
    en: "Previous",
    ar: "السابق",
    tu: "Sonraki",
    ru: ""
  },
  ADD_USER: {
    en: "Add User",
    ar: "إضافة مستخدم",
    tu: "Sonraki",
    ru: "Далее",
    fr: "Suivant"
  },
  ADD_CARD: {
    en: "Add Card",
    ar: "إضافة بطاقة",
    tu: "",
    ru: "",
    fr: ""
  },
  ADD_SUB_CARD: {
    en: "Add Sub Card",
    ar: "إضافة بطاقة",
    tu: "",
    ru: "",
    fr: ""
  },
  YOU_DONT_HAVE_ANY_CARD: {
    en: "You don’t have any cards please make it first the upload users",
    ar: "ليس لديك أي بطاقات، يرجى جعلها أولًا للمستخدمين الذين يقومون بالتحميل",
    tu: "",
    ru: "",
    fr: ""
  },
  YOU_DONT_HAVE_ANY_CARD_TO_ADD_USER: {
    en: "You don’t have any cards to add user",
    ar: "ليس لديك أي بطاقات لإضافة مستخدم",
    tu: "",
    ru: "",
    fr: ""
  },
  BROWSE: {
    en: "Browse",
    ar: "تصفح",
    tu: "",
    ru: "",
    fr: ""
  },
  DRAG_AND_DROP: {
    en: "Drag and drop files to upload",
    ar: "قم بسحب وإسقاط الملفات للتحميل",
    tu: "",
    ru: "",
    fr: ""
  },
  OR: {
    en: "or",
    an: "او",
    tu: "",
    ru: "",
    fr: ""
  },
  UPLOAD_FILE: {
    en: "Upload File",
    ar: "تحميل الملف",
    tu: "",
    ru: "",
    fr: ""
  },
  ALL: {
    en: "All",
    ar: "الكل",
    tu: "",
    ru: "",
    fr: ""
  },
  CORRECT: {
    en: "Correct",
    ar: "صحيح",
    tu: "",
    ru: "",
    fr: ""
  },
  ERROR: {
    en: "Error",
    ar: "خطأ",
    tu: "",
    ru: "",
    fr: ""
  },
  EXCEL_ERROR_MESSAGE: {
    en: "Are you sure you want to continue?",
    ar: "خطأ",
    tu: "",
    ru: "",
    fr: ""
  },
  ERROR_MODAL_MESSAGE: {
    en: "There is errors In your Excel sheet Submitting Data will remove the errored From your sheet, are you sure You want to continue review and submit?",
    ar: "خطأ",
    tu: "",
    ru: "",
    fr: ""
  },
  DATA_SUBMITTED_MESSAGE: {
    en: "Your Data Has been submitted successfully",
    ar: "خطأ",
    tu: "",
    ru: "",
    fr: ""
  },
  REVIEW_AND_SUBMIT: {
    en: "Review and Submit",
    ar: "مراجعة وإرسال",
    tu: "",
    ru: "",
    fr: ""
  },
  EXPORT_IN_EXCEL: {
    en: "Export in Excel Sheet",
    ar: "تصدير في ورقة Excel",
    tu: "",
    ru: "",
    fr: ""
  },
  EXPORT: {
    en: "Export",
    ar: "تصدير",
    tu: "",
    ru: "",
    fr: ""
  },
  EXPORT_TO_REGISTERED_EMPLOYEES: {
    en: "Export To Registered Employees",
    ar: " تصدير إلى الموظفين المسجلين",
    tu: "",
    ru: "",
    fr: ""
  },
  CONTACTS: {
    en: "Contacts",
    ar: "جهات الاتصال",
    tu: "",
    ru: "",
    fr: ""
  },
  POSITION: {
    en: "Position",
    ar: "الوظيفة",
    tu: "Konum",
    ru: "Позиция",
    fr: "Position"
  },
  POSITION_LAN1: {
    en: "Position Language 1",
    ar: "الوظيفة",
    tu: "Konum",
    ru: "Позиция",
    fr: "Position"
  },
  POSITION_LAN2: {
    en: "Position Language 2",
    ar: "الوظيفة",
    tu: "Konum",
    ru: "Позиция",
    fr: "Position"
  },
  COMPANY_LAN1: {
    ar: "اسم الشركة",
    en: "Company Language 1",
    tu: "Firma Adı",
    ru: "Название компании",
    fr: "Firma Adı"
  },
  COMPANY_LAN2: {
    ar: "اسم الشركة",
    en: "Company Language 2",
    tu: "Firma Adı",
    ru: "Название компании",
    fr: "Firma Adı"
  },
  COMPANY_NAME: {
    ar: "اسم الشركة",
    en: "Company Name",
    tu: "Firma Adı",
    ru: "Название компании",
    fr: "Firma Adı"
  },
  FACEBOOK: {
    en: "Facebook",
    ar: "فيسبوك",
    tu: "",
    ru: "",
    fr: ""
  },
  LINKED_IN: {
    en: "Linked In",
    ar: "لينكد إن",
    tu: "",
    ru: "",
    fr: ""
  },
  TELEGRAM: {
    en: "Telegram",
    ar: "Telegram",
    tu: "",
    ru: "",
    fr: ""
  },
  SNAPCHAT: {
    en: "Snapchat",
    ar: "Snapchat",
    tu: "",
    ru: "",
    fr: ""
  },
  SLACK: {
    en: "Slack",
    ar: "Slack",
    tu: "",
    ru: "",
    fr: ""
  },
  TWITTER: {
    en: "Twitter",
    ar: "Twitter",
    tu: "",
    ru: "",
    fr: ""
  },
  WHATSAPP: {
    en: "Whats app",
    ar: "Whats app",
    tu: "",
    ru: "",
    fr: ""
  },
  INSTERGRAM: {
    en: "Instagram",
    ar: "انستجرام",
    tu: "",
    ru: "",
    fr: ""
  },
  YOUTUBE: {
    en: "Youtube",
    ar: "يوتيوب",
    tu: "",
    ru: "",
    fr: ""
  },
  FAX: {
    en: "Fax",
    ar: "فاكس",
    tu: "",
    ru: "",
    fr: ""
  },
  TELEPHONE: {
    en: "Telephone",
    ar: "هاتف",
    tu: "",
    ru: "",
    fr: ""
  },
  DELETE_USER: {
    en: "Delete User",
    ar: "حذف المستخدم",
    tu: "",
    ru: "",
    fr: ""
  },
  CHOOSE_CARD: {
    en: "Choose Card",
    ar: "اختر بطاقة",
    tu: "",
    ru: "",
    fr: ""
  },
  USE_THIS_CARD: {
    en: "Use this card",
    ar: "استخدم هذا الكارت",
    tu: "",
    ru: "",
    fr: ""
  },
  DELETE: {
    en: "Delete",
    ar: "حذف",
    tu: "",
    ru: "",
    fr: ""
  },
  YES: {
    en: "Yes",
    ar: "نعم",
    tu: "",
    ru: "",
    fr: ""
  },
  NO: {
    en: "No",
    ar: "لا",
    tu: "",
    ru: "",
    fr: ""
  },
  ARE_YOU_SURE_TO_DELETE: {
    en: "Are you sure you want to delete this user?",
    ar: "هل أنت متأكد أنك تريد حذف هذا المستخدم؟",
    tu: "",
    ru: "",
    fr: ""
  },
  ARE_YOU_SURE_TO_DELETE_All_USERS: {
    en: "Are you sure you want to delete all users except admin?",
    ar: "هل أنت متأكد أنك تريد حذف هذا المستخدم؟",
    tu: "",
    ru: "",
    fr: ""
  },
  ARE_YOU_SURE_YOU_WANT_TO_CANCEL_EXCEL: {
    en: "Are you sure you want to cancel the Bulk upload, all employees in it will be removed.",
    ar: "هل أنت متأكد أنك تريد إلغاء التحميل المجمع، ستتم إزالة جميع الموظفين الموجودين فيه.",
    tu: "",
    ru: "",
    fr: ""
  },
  CANCEL_UPLOAD_EXCEL: {
    en: "Cancel uploading excel",
    ar: "الغاء تحميل الاكسل",
    tu: "",
    ru: "",
    fr: ""
  },
  NO_NOTIFICATION_FOUND: {
    en: "No Notification Found",
    ar: "لم يتم العثور على إشعارات",
    tu: "",
    ru: "",
    fr: ""
  },
  NOTIFICATION_DETAILS: {
    en: "Notification Details",
    ar: "تفاصيل الإشعار",
    tu: "",
    ru: "",
    fr: ""
  },
  INVOICE_ID: {
    en: "Invoice ID",
    ar: "معرف الفاتورة",
    tu: "",
    ru: "",
    fr: ""
  },
  INVOICE_DETAILS: {
    en: "Invoice Details",
    ar: "تفاصيل الفاتورة",
    tu: "",
    ru: "",
    fr: ""
  },
  AMOOUNT: {
    en: "Amount",
    ar: "كمية",
    tu: "",
    ru: "",
    fr: ""
  },
  DATE: {
    en: "Date",
    ar: "التاريخ",
    tu: "",
    ru: "",
    fr: ""
  },
  TIME: {
    en: "Time",
    ar: "الوقت",
    tu: "",
    ru: "",
    fr: ""
  },
  PAY_NOW: {
    en: "Pay Now",
    ar: "ادفع الان",
    tu: "",
    ru: "",
    fr: ""
  },
  STATUS: {
    en: "Status",
    ar: "الحالة",
    tu: "",
    ru: "",
    fr: ""
  },
  ACTION: {
    en: "Action",
    ar: "عمل",
    tu: "",
    ru: "",
    fr: ""
  },
  NO_INVOICES_FOUND: {
    en: "No invoices found",
    ar: "لم يتم العثور على فواتير",
    tu: "",
    ru: "",
    fr: ""
  },
  SEARCH: {
    en: "Search",
    ar: "ابحث",
    tu: "",
    ru: "",
    fr: ""
  },
  FILTER: {
    en: "Filter",
    ar: "فلتر",
    tu: "",
    ru: "",
    fr: ""
  },
  YOUR_PHOTO: {
    en: "Your Photo",
    ar: "صورتك",
    tu: "",
    ru: "",
    fr: ""
  },
  UPLOAD_PHOTO: {
    en: "Upload Photo",
    ar: "تحميل الصور",
    tu: "",
    ru: "",
    fr: ""
  },
  LOGO: {
    en: "Logo",
    ar: "شعار",
    tu: "",
    ru: "",
    fr: ""
  },
  UPLOAD_LOGO: {
    en: "Upload Logo",
    ar: "تحميل الشعار",
    tu: "",
    ru: "",
    fr: ""
  },
  PERSONAL_IFO: {
    en: "Personal Info",
    ar: "معلومات شخصية",
    tu: "",
    ru: "",
    fr: ""
  },
  YOUR_CONTANT: {
    en: "Your Contact",
    ar: "اتصالك",
    tu: "",
    ru: "",
    fr: ""
  },
  LINKS: {
    en: "Links",
    ar: "روابط",
    tu: "",
    ru: "",
    fr: ""
  },
  ASSIGN_TO_USERS: {
    en: "Assign to Users",
    ar: "تعيين للمستخدمين",
    tu: "",
    ru: "",
    fr: ""
  },
  NOTIFICATION: {
    en: "Notification",
    ar: "إعلام",
    tu: "",
    ru: "",
    fr: ""
  },
  NOTIFICATIONS: {
    en: "Notifications",
    ar: "إعلام",
    tu: "",
    ru: "",
    fr: ""
  },
  RESEND_CODE: {
    en: "Resend Code",
    ar: "إعادة إرسال الرمز",
    tu: "",
    ru: "",
    fr: ""
  },
  SEND: {
    en: "Send",
    ar: " ارسل ",
    tu: "",
    ru: "",
    fr: ""
  },
  STEP_ONE: {
    en: "Step 1",
    ar: "الخطوة 1",
    tu: "",
    ru: "",
    fr: ""
  },
  STEP_TWO: {
    en: "Step 2",
    ar: "الخطوة 2",
    tu: "",
    ru: "",
    fr: ""
  },
  STEP_THREE: {
    en: "Step 3",
    ar: "الخطوة 3",
    tu: "",
    ru: "",
    fr: ""
  },
  LAYOUT: {
    en: "Layout",
    ar: "تخطيط",
    tu: "",
    ru: "",
    fr: ""
  },
  ENTER_DATA: {
    en: "Enter Data",
    ar: "أدخل البيانات",
    tu: "",
    ru: "",
    fr: ""
  },
  ENTER_MESSAGE: {
    en: "Enter Message",
    ar: "أدخل الرساله",
    tu: "",
    ru: "",
    fr: ""
  },
  LUNACH: {
    en: "Lunach",
    ar: "إطلاق",
    tu: "",
    ru: "",
    fr: ""
  },
  UPDATE: {
    en: "Update",
    ar: "تحديث",
    tu: "",
    ru: "",
    fr: ""
  },
  STATISTICS: {
    en: "Statistics",
    ar: "الإحصائيات",
    tu: "",
    ru: "",
    fr: ""
  },
  SELECT_YEAR: {
    en: "select year",
    ar: "اختر السنة",
    tu: "",
    ru: "",
    fr: ""
  },
  NOT_REGISTERED: {
    en: "not registered",
    ar: " غير مسجل",
    tu: "",
    ru: "",
    fr: ""
  },
  FREE_TRIAL: {
    en: "Free Trial",
    ar: "تجربة مجانية",
    tu: "",
    ru: "",
    fr: ""
  },
  FREE_TRAIL_EXPIRED: {
    en: "Sorry, your free trial expired, you have to upgrade it to continue.",
    ar: "انتهت صلاحية التجربة المجانية ، يجب عليك ترقيتها للمتابعة",
    tu: "",
    ru: "",
    fr: ""
  },
  MONTH: {
    en: "Month",
    ar: "شهر",
    tu: "",
    ru: "",
    fr: ""
  },
  UPGRADE_DESC: {
    en: "Upgrade today to enjoy enhanced benefits. Don't miss out on all that Swipy has to offer.",
    ar: "قم بالترقية اليوم لتستمتع بالمزايا المحسنة. لا تفوت كل ما يقدمه Swipy.",
    tu: "",
    ru: "",
    fr: ""
  },
  UPGRADE_DESC_FOR_SUBSCRIBED: {
    en: "You are subscribed to Standard Plan",
    ar: "أنت مشترك في الخطة القياسية",
    tu: "",
    ru: "",
    fr: ""
  },
  ADDED_CARD: {
    en: "Your digital business card is ready to impress. Simply click 'Assign to Users' to share it with your connections.",
    ar: "بطاقة عملك الرقمية جاهزة لإثارة إعجابك. ما عليك سوى النقر فوق تعيين للمستخدمين لمشاركتها مع زملائك.",
    tu: "",
    ru: "",
    fr: ""
  },

  DAYS: {
    en: "Days",
    ar: "أيام",
    tu: "",
    ru: "",
    fr: ""
  },
  DAY: {
    en: "Day",
    ar: "يوم",
    tu: "",
    ru: "",
    fr: ""
  },
  CURRENT_NEW_PASSWORDS_SAME: {
    ar: "كلمة المرور الحالية وكلمة المرور الجديدة لا يمكن أن تكونا نفسهما!",
    en: "Current password and new password cannot be the same!",
    tu: "",
    ru: "",
    fr: ""
  },
  CONNECTION_ERROR: {
    ar: "خطأ في الاتصال!",
    en: "Connection Error!",
    tu: "Giriş Yap",
    ru: "Войти",
    fr: "S'identifier",
  },
  CHECK_YOUR_NETWORK: {
    ar: "يرجى التحقق من اتصالك بالإنترنت والمحاولة مرة أخرى.",
    en: "Please check your internet connection and try again.",
    tu: "Giriş Yap",
    ru: "Войти",
    fr: "S'identifier",
  },
  FILTER_BY_DATE: {
    ar: "تصفية حسب التاريخ",
    en: "Filter By Date",
    tu: "Giriş Yap",
    ru: "Войти",
    fr: "S'identifier",
  },
  COPY: {
    ar: "انسخ",
    en: "Copy",
    tu: "Giriş Yap",
    ru: "Войти",
    fr: "S'identifier",
  },
  COPIED_SUCCESSFULLY: {
    ar: "تم النسخ بنجاح",
    en: "Copied To Clipboard Successfully",
    tu: "Giriş Yap",
    ru: "Войти",
    fr: "S'identifier",
  },
  CARD_LANGUAGE: {
    en: "English Card",
    ar: "Arabic Card",
    fr: "French Card",
    ru: "Russian Card",
    tu: "Turkish Card",
  },
  CARD_LANGUAGE_2: {
    en: "English",
    ar: "Arabic",
    fr: "French",
    ru: "Russian",
    tu: "Turkish",
  },
  LANGUGES_VALUE: {
    en: "English",
    ar: "العربية",
    fr: "Français",
    ru: "русский",
  },
  YOUR_INVOICE_PAID: {
    en: "Your invoice paid successfully",
    ar: "تم دفع فاتورتك بنجاح",
    fr: "Votre facture a été payée avec succès",
    ru: "Ваш счет успешно оплачен",
    tu: "Faturanız başarıyla ödendi"
  },
  WRITE_WITH_CHOOSEN_DATA: {
    en: "Write data with the choosen language",
    ar: "يرجي كتابة البيانات باللغة المختارة",
    fr: "Écrire des données avec la langue choisie",
    ru: "Запись данных на выбранном языке",
    tu: "Verileri seçilen dille yazın"
  },
  UNSUBSCRIBE: {
    en: "Unsubscribe",
    ar: "",
    fr: "",
    tu: "",
    ru: ""
  },
  ARE_YOU_SURE_TO_UNSUBSCRIBE: {
    en: "Are you sure you want to unsubscribe ?",
    ar: "هل أنت متأكد أنك تريد إلغاء الاشتراك ؟",
    fr: "",
    tu: "",
    ru: ""
  },
  REQUEST_CUSTOM_DESIGN: {
    en: "Request custom design",
    ar: "طلب تصميم مخصص",
    fr: "Demander une conception personnalisée",
    tu: "Özel tasarım isteyin",
    ru: "Запросить индивидуальный дизайн"
  },
  JANUARY: {
    en: "January",
    ar: "يناير",
    tu: "Gelecek Yıl",
    ru: "Следующий год",
    fr: "L'année prochaine",
  },
  FEBRUARY: {
    en: "February ",
    ar: "فبراير",
    tu: "Gelecek Yıl",
    ru: "Следующий год",
    fr: "L'année prochaine",
  },
  MARCH: {
    en: "March  ",
    ar: "مارس",
    tu: "Gelecek Yıl",
    ru: "Следующий год",
    fr: "L'année prochaine",
  },
  APRIL: {
    en: "April",
    ar: "أبريل",
    tu: "Gelecek Yıl",
    ru: "Следующий год",
    fr: "L'année prochaine",
  },
  MAY: {
    en: "May ",
    ar: "مايو",
    tu: "Gelecek Yıl",
    ru: "Следующий год",
    fr: "L'année prochaine",
  },
  JUNE: {
    en: "June",
    ar: "يونيو",
    tu: "Gelecek Yıl",
    ru: "Следующий год",
    fr: "L'année prochaine",
  },
  JULY: {
    en: "July",
    ar: "يوليو",
    tu: "Gelecek Yıl",
    ru: "Следующий год",
    fr: "L'année prochaine",
  },
  AUGUST: {
    en: "August",
    ar: "أغسطس",
    tu: "Gelecek Yıl",
    ru: "Следующий год",
    fr: "L'année prochaine",
  },
  SEPTEMBER: {
    en: "September",
    ar: "سبتمبر",
    tu: "Gelecek Yıl",
    ru: "Следующий год",
    fr: "L'année prochaine",
  },
  OCTOBER: {
    en: "October",
    ar: "أكتوبر",
    tu: "Gelecek Yıl",
    ru: "Следующий год",
    fr: "L'année prochaine",
  },
  NOVEMBER: {
    en: "November",
    ar: "نوفمبر",
    tu: "Gelecek Yıl",
    ru: "Следующий год",
    fr: "L'année prochaine",
  },
  DESEMBER: {
    en: "December",
    ar: "ديسمبر",
    tu: "Gelecek Yıl",
    ru: "Следующий год",
    fr: "L'année prochaine",
  },
  CUSTOM: {
    en: "Custom",
    ar: "مخصص",
    tu: "Gelecek Yıl",
    ru: "Следующий год",
    fr: "L'année prochaine",
  },
  EXCEL_EDIT_EMPLOYEE_TEXT: {
    en: "Can employees edit their phone Numbers?",
    ar: "هل يمكن للموظفين تعديل أرقام هواتفهم؟",
    tu: "",
    ru: "",
    fr: ""
  },
  YOU_GONNA_ADD: {
    en: "You gonna to add",
    ar: "أنت ستعمل على إضافة",
    tu: "",
    ru: "",
    fr: ""
  },
  OF: {
    en: "of",
    ar: "من",
    tu: "",
    ru: "",
    fr: ""
  },
  THE_REST_OF: {
    en: "the rest of",
    ar: "بقية",
    tu: "",
    ru: "",
    fr: ""
  },
  REST_OF_EXCEL_MESSAGE: {
    en: "will not be added until you corrected their information, you can export, edit, and reupload from the Error list",
    ar: "لن تتم إضافتها حتى تقوم بتصحيح معلوماتها، ويمكنك التصدير والتحرير وإعادة التحميل من قائمة الأخطاء",
    tu: "",
    ru: "",
    fr: ""
  },
  /////////////////////////////////////////////////// Addmix Store ///////////////////////////////////////////////////
  ADD_MIX: {
    en: "Addmix Store",
    ar: "متجر ادمكس",
    tu: "",
    ru: "",
    fr: ""
  },
  PRODUCTS: {
    en: "Products",
    ar: "منتجات",
    tu: "",
    ru: "",
    fr: ""
  },
  CATEGORIES: {
    en: "Categories",
    ar: "الفئات",
    tu: "",
    ru: "",
    fr: ""
  },
  ADMINS: {
    en: "Admins",
    ar: "المسؤولين",
    tu: "",
    ru: "",
    fr: ""
  },
  ORDERS: {
    en: "Orders",
    ar: "الطلبات",
    tu: "",
    ru: "",
    fr: ""
  },
  ID: {
    en: "id",
    ar: "الرقم التعريفي",
  },
  PRODUCT_NAME: {
    en: "Product Name",
    ar: "أسم المنتج"
  },
  PRODUCT_PRICE: {
    en: "Product Price",
    ar: "سعر المنتج"
  },
  PRICE_DISCOUNT: {
    en: "Price Discount",
    ar: "سعر بعد الخصم"
  },
  NO_PRODUCTS_FOUND: {
    en: "No Products Found",
    ar: "لم يتم العثور علي منتجات"
  },
  PRODUCTS: {
    en: "Products",
    ar: "المنتجات"
  },
  IS_ACTIVE: {
    en: "Active",
    ar: "نشط"
  },
  QUANTITY: {
    en: "Quantity",
    ar: "الكمية"
  },
  // SEARCH: {
  //   en: "Search products...",
  //   ar: "ابحث عن منتجات..."
  // },
  FILTER: {
    en: "Filter",
    ar: "تصفية"
  },
  FILTER_PRODUCTS: {
    en: "Filter Products",
    ar: "تصفية المنتجات"
  },
  CATEGORY: {
    en: "Category",
    ar: "الفئة"
  },
  SUB_CATEGORY: {
    en: "Sub Category",
    ar: "الفئة الفرعية"
  },
  BRAND: {
    en: "Brand",
    ar: "الماركة"
  },
  COLLECTION: {
    en: "Collection",
    ar: "المجموعة"
  },
  RESET: {
    en: "Reset",
    ar: "إعادة تعيين"
  },
  APPLY_FILTERS: {
    en: "Apply Filters",
    ar: "تطبيق التصفية"
  },
  ALL_CATEGORIES: {
    en: "All Categories",
    ar: "كل الفئات"
  },
  ALL_SUB_CATEGORIES: {
    en: "All Sub Categories",
    ar: "كل الفئات الفرعية"
  },
  ALL_BRANDS: {
    en: "All Brands",
    ar: "كل الماركات"
  },
  ALL_COLLECTIONS: {
    en: "All Collections",
    ar: "كل المجموعات"
  },
  STOCK_STATUS: {
    en: "Stock Status",
    ar: "حالة المخزون"
  },
  IN_STOCK: {
    en: "In Stock",
    ar: "متوفر"
  },
  LOW_STOCK: {
    en: "Low Stock",
    ar: "منخفض"
  },
  OUT_OF_STOCK: {
    en: "Out of Stock",
    ar: "غير متوفر"
  },
  SAVINGS: {
    en: "Savings",
    ar: "التوفير"
  },
  HAS_DISCOUNT: {
    en: "Has Discount",
    ar: "به خصم"
  },
  ID: {
    en: "ID",
    ar: "الرقم"
  },
  LOADING_PRODUCTS: {
    en: "Loading Products",
    ar: "جاري تحميل المنتجات"
  },
  FAILED_TO_LOAD_PRODUCTS: {
    en: "Failed to load products",
    ar: "فشل تحميل المنتجات"
  },
  TRY_AGAIN: {
    en: "Try Again",
    ar: "حاول مرة أخرى"
  },
  // كلمات إضافية ممكن تحتاجها
  EDIT_PRODUCT: {
    en: "Edit Product",
    ar: "تعديل المنتج"
  },
  DELETE_PRODUCT: {
    en: "Delete Product",
    ar: "حذف المنتج"
  },
  PRODUCT_IMAGES: {
    en: "Product Images",
    ar: "صور المنتج"
  },
  PRODUCT_VARIANTS: {
    en: "Product Variants",
    ar: "أنواع المنتج"
  },
  COLORS: {
    en: "Colors",
    ar: "الألوان"
  },
  SIZES: {
    en: "Sizes",
    ar: "المقاسات"
  },
  INVENTORY: {
    en: "Inventory",
    ar: "المخزون"
  },
  TOTAL_INVENTORY: {
    en: "Total Inventory",
    ar: "إجمالي المخزون"
  },
  ACTIONS: {
    en: "Actions",
    ar: "الإجراءات"
  },
  VIEW_DETAILS: {
    en: "View Details",
    ar: "عرض التفاصيل"
  },
  EXPORT_PRODUCTS: {
    en: "Export Products",
    ar: "تصدير المنتجات"
  },
  IMPORT_PRODUCTS: {
    en: "Import Products",
    ar: "استيراد المنتجات"
  },
  BULK_ACTIONS: {
    en: "Bulk Actions",
    ar: "إجراءات جماعية"
  },
  SELECT_ALL: {
    en: "Select All",
    ar: "تحديد الكل"
  },
  // كلمات للـ pagination
  SHOWING: {
    en: "Showing",
    ar: "عرض"
  },
  TO: {
    en: "to",
    ar: "إلى"
  },
  OF: {
    en: "of",
    ar: "من"
  },
  ENTRIES: {
    en: "entries",
    ar: "عنصر"
  },
  PREVIOUS: {
    en: "Previous",
    ar: "السابق"
  },
  NEXT: {
    en: "Next",
    ar: "التالي"
  },
  // كلمات للـ status
  STATUS: {
    en: "Status",
    ar: "الحالة"
  },
  ACTIVE: {
    en: "Active",
    ar: "نشط"
  },
  INACTIVE: {
    en: "Inactive",
    ar: "غير نشط"
  },
  DRAFT: {
    en: "Draft",
    ar: "مسودة"
  },
  PUBLISHED: {
    en: "Published",
    ar: "منشور"
  },
  // كلمات للـ dates
  CREATED_AT: {
    en: "Created At",
    ar: "تاريخ الإنشاء"
  },
  UPDATED_AT: {
    en: "Updated At",
    ar: "تاريخ التحديث"
  },
  LAST_UPDATED: {
    en: "Last Updated",
    ar: "آخر تحديث"
  },
  BACK_TO_PRODUCTS: {
    en: "Back to Products",
    ar: "العودة للمنتجات"
  },
  PRODUCT_INFO: {
    en: "Product Information",
    ar: "معلومات المنتج"
  },
  DESCRIPTION: {
    en: "Description",
    ar: "الوصف"
  },
  AVAILABLE_VARIANTS: {
    en: "Available Variants",
    ar: "الأنواع المتاحة"
  },
  SELECTED_VARIANT: {
    en: "Selected Variant Details",
    ar: "تفاصيل النوع المختار"
  },
  TOP_SELLER: {
    en: "Top Seller",
    ar: "الأكثر مبيعاً"
  },
  TREND: {
    en: "Trending Now",
    ar: "الأكثر شهرة"
  },
  IS_NEW: {
    en: "Is New",
    ar: "وصل حديثا"
  },
  ACTIVE_PRODUCT: {
    en: "Active Product",
    ar: "منتج نشط"
  },
  INACTIVE_PRODUCT: {
    en: "Inactive Product",
    ar: "منتج غير نشط"
  },

  ACTIVE: {
    en: "Active",
    ar: "نشط"
  },
  INACTIVE: {
    en: "Inactive",
    ar: "غير نشط"
  },
  ERROR: {
    en: "Error",
    ar: "خطأ"
  },
  LOADING: {
    en: "Loading...",
    ar: "جاري التحميل..."
  },

  // كلمات الـ Variants
  COLOR: {
    en: "Color",
    ar: "اللون"
  },
  SIZE: {
    en: "Size",
    ar: "المقاس"
  },
  SKU: {
    en: "SKU",
    ar: "الرمز"
  },
  STOCK: {
    en: "Stock",
    ar: "المخزون"
  },
  CATEGORY_MANAGEMENT: {
    en: "Category Management",
    ar: "إدارة الفئات"
  },
  COLORS_SIZES_MANAGEMENT: {
    en: "Colors/Sizes Management",
    ar: "إدارة الألوان و المقاسات"
  },
  PROMO_CODES_MANAGEMENT: {
    en: "Promo Codes Management",
    ar: "إدارة أكواد الخصم"
  },
  ORDERS_MANAGEMENT: {
    en: 'Orders Management',
    ar: 'إدارة الطلبات'
  },
  STATES: {
    en: 'Shipping cost Management',
    ar: 'ادارة تكاليف الشحن'
  },
  AVAILABLE: {
    en: "Available",
    ar: "متوفر"
  },
  WITHOUT_BOX_QUANTITY: {
    en: "Quantity Without Box",
    ar: "الكمية بدون العلبة"
  },
  WITH_BOX_QUANTITY: {
    en: "Quantity With Box",
    ar: "الكمية بالعلبة"
  },
  IN_STOCK: {
    en: "In Stock",
    ar: "متوفر"
  },
  LOW_STOCK: {
    en: "Low Stock",
    ar: "منخفض"
  },
  OUT_OF_STOCK: {
    en: "Out of Stock",
    ar: "غير متوفر"
  },

  // كلمات الـ Pricing
  PRICE: {
    en: "Price",
    ar: "السعر"
  },
  DISCOUNT_PRICE: {
    en: "Discount Price",
    ar: "سعر الخصم"
  },
  ORIGINAL_PRICE: {
    en: "Original Price",
    ar: "السعر الأصلي"
  },

  // كلمات الـ Product Status
  STATUS: {
    en: "Status",
    ar: "الحالة"
  },
  DRAFT: {
    en: "Draft",
    ar: "مسودة"
  },
  PUBLISHED: {
    en: "Published",
    ar: "منشور"
  },

  // كلمات إضافية للـ Product Details
  WEIGHT: {
    en: "Weight",
    ar: "الوزن"
  },
  TAGS: {
    en: "Tags",
    ar: "الوسوم"
  },

  PRIMARY_IMAGE: {
    en: "Primary Image",
    ar: "الصورة الرئيسية"
  },
  GALLERY: {
    en: "Gallery",
    ar: "المعرض"
  },
  VIEW_LARGER: {
    en: "View Larger",
    ar: "عرض بحجم أكبر"
  },

  UPDATE_PRODUCT: {
    en: "Update Product",
    ar: "تحديث المنتج"
  },
  DEACTIVATE_PRODUCT: {
    en: "Deactivate Product",
    ar: "تعطيل المنتج"
  },
  ACTIVATE_PRODUCT: {
    en: "Activate Product",
    ar: "تفعيل المنتج"
  },

  // كلمات الـ Inventory
  TOTAL_QUANTITY: {
    en: "Total Quantity",
    ar: "إجمالي الكمية"
  },
  RESERVED_QUANTITY: {
    en: "Reserved Quantity",
    ar: "الكمية المحجوزة"
  },
  AVAILABLE_QUANTITY: {
    en: "Available Quantity",
    ar: "الكمية المتاحة"
  },
  LOW_STOCK_THRESHOLD: {
    en: "Low Stock Threshold",
    ar: "حد المخزون المنخفض"
  },

  // كلمات الـ Variant Details
  VARIANT_DETAILS: {
    en: "Variant Details",
    ar: "تفاصيل النوع"
  },
  SELECT_COLOR: {
    en: "Select Color",
    ar: "اختر اللون"
  },
  SELECT_SIZE: {
    en: "Select Size",
    ar: "اختر المقاس"
  },
  NO_COLOR: {
    en: "No Color",
    ar: "بدون لون"
  },
  NO_SIZE: {
    en: "No Size",
    ar: "بدون مقاس"
  },
  ONE_SIZE: {
    en: "One Size",
    ar: "مقاس واحد"
  },

  // كلمات الـ Pricing Details
  CURRENT_PRICE: {
    en: "Current Price",
    ar: "السعر الحالي"
  },
  DISCOUNT: {
    en: "Discount",
    ar: "الخصم"
  },
  NO_DISCOUNT: {
    en: "No Discount",
    ar: "لا يوجد خصم"
  },

  // كلمات الـ Navigation
  PREVIOUS_PRODUCT: {
    en: "Previous Product",
    ar: "المنتج السابق"
  },
  NEXT_PRODUCT: {
    en: "Next Product",
    ar: "المنتج التالي"
  },
  CLOSE: {
    en: "Close",
    ar: "إغلاق"
  },

  // كلمات الـ Messages
  PRODUCT_NOT_FOUND: {
    en: "Product Not Found",
    ar: "المنتج غير موجود"
  },
  LOADING_PRODUCT_DETAILS: {
    en: "Loading Product Details...",
    ar: "جاري تحميل تفاصيل المنتج..."
  },
  FAILED_TO_LOAD_PRODUCT: {
    en: "Failed to load product details",
    ar: "فشل تحميل تفاصيل المنتج"
  },

  // كلمات الـ Measurements
  GRAMS: {
    en: "g",
    ar: "جرام"
  },
  KILOGRAMS: {
    en: "kg",
    ar: "كجم"
  },

  // كلمات الـ Status Badges
  BADGE_NEW: {
    en: "New",
    ar: "جديد"
  },
  BADGE_HOT: {
    en: "Hot",
    ar: "مميز"
  },
  BADGE_FEATURED: {
    en: "Featured",
    ar: "مميز"
  },
  BADGE_SALE: {
    en: "Sale",
    ar: "تخفيض"
  },

  // كلمات الـ Actions في الجدول
  VIEW_DETAILS: {
    en: "View Details",
    ar: "عرض التفاصيل"
  },
  QUICK_VIEW: {
    en: "Quick View",
    ar: "عرض سريع"
  },
  ADD_TO_CART: {
    en: "Add to Cart",
    ar: "أضف إلى السلة"
  },
  ADD_TO_WISHLIST: {
    en: "Add to Wishlist",
    ar: "أضف إلى المفضلة"
  },
  EDIT_PRODUCT: {
    en: "Edit Product",
    ar: "تعديل المنتج"
  },
  ADD_VARIANT: {
    en: "Add Size/Color",
    ar: "إضافة لون/مقاس"
  },
  UPDATE_PRICES: {
    en: "Update Prices",
    ar: "تحديث الأسعار"
  },
  DEACTIVATE_PRODUCT: {
    en: "Deactivate Product",
    ar: "تعطيل المنتج"
  },
  ACTIVATE_PRODUCT: {
    en: "Activate Product",
    ar: "تفعيل المنتج"
  },
  REMOVE_TOP_SELLER: {
    en: "Remove from Top Sellers",
    ar: "إزالة من الأكثر مبيعاً"
  },
  MARK_TOP_SELLER: {
    en: "Mark as Top Seller",
    ar: "وضع كأكثر مبيعاً"
  },
  REMOVE_TREDN: {
    en: "Remove from Trending list",
    ar: "إزالة من الأكثر شهرة"
  },
  MARK_AS_TREND: {
    en: "Mark as Tredn",
    ar: "وضع في قائمة الأكثر شهرة"
  },
  REMOVE_IS_NEW: {
    en: "Remove from Is New list",
    ar: "تغير لمنتج قديم"
  },
  MARK_AS_NEW: {
    en: "Mark as New product",
    ar: "تغير لمنتج جديد"
  },
  CONFIRM_ACTION: {
    en: "Confirm Action",
    ar: "تأكيد التغير",
  },
  CONFIRM: {
    en: "Confirm",
    ar: "تأكيد",
  },
  STOCK_MANAGEMENT: { en: 'Stock Management', ar: 'إدارة المخزون' },
  ADD_MOVEMENT: { en: 'Add Stock Movement', ar: 'إضافة حركة مخزون' },
  VARIANT: { en: 'Variant', ar: 'المنتج' },
  MOVEMENT_TYPE: { en: 'Movement Type', ar: 'نوع الحركة' },
  QUANTITY: { en: 'Quantity', ar: 'الكمية' },
  REASON: { en: 'Reason', ar: 'السبب' },
  SUBMIT: { en: 'Submit', ar: 'حفظ' },
  CANCEL: { en: 'Cancel', ar: 'إلغاء' },
  MOVEMENTS_HISTORY: { en: 'Movements History', ar: 'سجل الحركات' },
  DATE: { en: 'Date', ar: 'التاريخ' },
  PRODUCT: { en: 'Product', ar: 'المنتج' },
  SKU: { en: 'SKU', ar: 'رمز المنتج' },
  TYPE: { en: 'Type', ar: 'النوع' },
  CURRENT_STOCK: { en: 'Current Stock', ar: 'المخزون الحالي' },
  RESERVED: { en: 'Reserved', ar: 'محجوز' },
  AVAILABLE: { en: 'Available', ar: 'متاح' },
  COLOR: { en: 'Color', ar: 'اللون' },
  SIZE: { en: 'Size', ar: 'المقاس' },
  FILTER_BY_TYPE: { en: 'Filter by Type', ar: 'تصفية حسب النوع' },
  ALL_TYPES: { en: 'All Types', ar: 'كل الأنواع' },
  FILTER_BY_VARIANT: { en: 'Filter by Variant', ar: 'تصفية حسب المنتج' },
  ALL_VARIANTS: { en: 'All Variants', ar: 'كل المنتجات' },
  SELECT_VARIANT: { en: 'Select Variant', ar: 'اختر المنتج' },
  SELECT_TYPE: { en: 'Select Type', ar: 'اختر النوع' },
  REQUIRED_FIELD: { en: 'This field is required', ar: 'هذا الحقل مطلوب' },
  NO_MOVEMENTS: { en: 'No movements found', ar: 'لا توجد حركات' },
  RESET_FILTERS: { en: 'Reset Filters', ar: 'إعادة تعيين الفلاتر' },
  ADD_PRODUCT: { en: 'Add New Product', ar: 'إضافة منتج جديد' },
  BASIC_INFO: { en: 'Basic Information', ar: 'المعلومات الأساسية' },
  IMAGES: { en: 'Product Images', ar: 'صور المنتج' },
  NAME_EN: { en: 'Product Name (English)', ar: 'اسم المنتج (الإنجليزية)' },
  NAME_AR: { en: 'Product Name (Arabic)', ar: 'اسم المنتج (العربية)' },
  COLLECTION: { en: 'Collection', ar: 'المجموعة' },
  CATEGORY: { en: 'Category', ar: 'الفئة' },
  SUB_CATEGORY: { en: 'Sub Category', ar: 'الفئة الفرعية' },
  UPLOAD_IMAGES: { en: 'Upload Product Images', ar: 'رفع صور المنتج' },
  DRAG_DROP: { en: 'Drag and drop images here or click to select', ar: 'اسحب وأفلت الصور هنا أو انقر للاختيار' },
  PRIMARY_IMAGE: { en: 'Primary Image', ar: 'الصورة الرئيسية' },
  SET_PRIMARY: { en: '⭐ Set Primary', ar: '⭐ اجعلها رئيسية' },
  REMOVE: { en: '✕ Remove', ar: '✕ حذف' },
  ADD: { en: 'Add', ar: 'إضافة' },
  SELECT: { en: 'Select...', ar: 'اختر...' },
  SUCCESS: { en: '✅ Product added successfully!', ar: '✅ تمت إضافة المنتج بنجاح!' },
  IMAGE_COUNT: { en: 'Images uploaded', ar: 'صور مرفوعة' },
  REQUIRED: {
    en: '(Required)',
    ar: '(مطلوب)'
  },
  DESC_EN: {
    en: 'Description (English)',
    ar: 'الوصف (إنجليزي)'
  },
  DESC_AR: {
    en: 'Description (Arabic)',
    ar: 'الوصف (عربي)'
  },
  ALL_COLLECTIONS: {
    en: 'All Collections',
    ar: 'جميع المجموعات'
  },
  ALL_CATEGORIES: {
    en: 'All Categories',
    ar: 'جميع الفئات'
  },
  ALL_SUB_CATEGORIES: {
    en: 'All Sub Categories',
    ar: 'جميع الفئات الفرعية'
  },
  ALL_BRANDS: {
    en: 'All Brands',
    ar: 'جميع العلامات التجارية'
  },
  IMAGES: {
    en: 'Images',
    ar: 'الصور'
  },
  UPLOAD_IMAGES: {
    en: 'Upload Images',
    ar: 'رفع الصور'
  },
  DRAG_DROP: {
    en: 'Drag and drop images here or click to select',
    ar: 'اسحب وأسقط الصور هنا أو انقر للاختيار'
  },
  CLICK_TO_SELECT: {
    en: 'Click to select images',
    ar: 'انقر لاختيار الصور'
  },
  SET_PRIMARY: {
    en: 'Set as Primary',
    ar: 'اجعله الصورة الرئيسية'
  },
  ADD_PRODUCT: {
    en: 'Add Product',
    ar: 'إضافة المنتج'
  },
  PRODUCT_CREATED: {
    en: 'Product created successfully!',
    ar: 'تم إنشاء المنتج بنجاح!'
  },
  ADD_IMAGES: {
    en: 'Add Image',
    ar: 'إضافة صورة'
  },
  ADD_NEW_BRAND: { ar: "إضافة ماركة جديدة", en: "Add New Brand" },
  EDIT_BRAND: { ar: "تعديل ماركة", en: "Edit Brand" },
  CLEAR_SEARCH: { ar: "مسح البحث", en: "Clear Search" },
  BRAND_IMAGE: { ar: "صورة الماركة", en: "Brand Image" },
  BRAND_NAME_EN: { ar: "الاسم بالإنجليزية", en: "Name (English)" },
  BRAND_NAME_AR: { ar: "الاسم بالعربية", en: "Name (Arabic)" },
  DELETE_CONFIRM: { ar: "هل أنت متأكد من الحذف؟", en: "Are you sure you want to delete?" },
  SUCCESS_ADD: { ar: "✅ تمت الإضافة بنجاح", en: "✅ Added successfully" },
  SUCCESS_EDIT: { ar: "✅ تم التعديل بنجاح", en: "✅ Edited successfully" },
  SUCCESS_DELETE: { ar: "✅ تم الحذف بنجاح", en: "✅ Deleted successfully" },
  ERROR_FETCH: { ar: "فشل تحميل الماركات", en: "Failed to load brands" },
  ERROR_ADD: { ar: "فشل إضافة الماركة", en: "Failed to add brand" },
  ERROR_EDIT: { ar: "فشل التعديل", en: "Failed to edit brand" },
  ERROR_DELETE: { ar: "فشل الحذف", en: "Failed to delete brand" },
  REQUIRED_FIELDS: { ar: "الرجاء ملء جميع الحقول المطلوبة", en: "Please fill all required fields" },
  NO_CHANGES: { ar: "لم يتم إجراء أي تغييرات", en: "No changes made" },
  NO_BRANDS: { ar: "لا توجد ماركات", en: "No brands found" },
  NO_RESULTS: { ar: "🔍 لا توجد نتائج للبحث", en: "🔍 No search results" },
  EDIT: { ar: "تعديل", en: "Edit" },
  ADD_NEW_CATEGORY: { ar: "إضافة فئة جديدة", en: "Add New Category" },
  EDIT_CATEGORY: { ar: "تعديل الفئة", en: "Edit Category" },
  CATEGORY_NAME_EN: { ar: "اسم الفئة بالإنجليزية", en: "Category Name (English)" },
  CATEGORY_NAME_AR: { ar: "اسم الفئة بالعربية", en: "Category Name (Arabic)" },
  CATEGORY_IMAGE: { ar: "صورة الفئة", en: "Category Image" },
  COLLECTION: { ar: "المجموعة", en: "Collection" },
  SELECT_COLLECTION: { ar: "اختر المجموعة", en: "Select Collection" },
  NO_CATEGORIES: { ar: "لا توجد فئات", en: "No Categories" },
  ADD_NEW_COLLECTION: { ar: "إضافة مجموعة جديدة", en: "Add New Collection" },
  EDIT_COLLECTION: { ar: "تعديل المجموعة", en: "Edit Collection" },
  COLLECTION_NAME_EN: { ar: "اسم المجموعة بالإنجليزية", en: "Collection Name (English)" },
  COLLECTION_NAME_AR: { ar: "اسم المجموعة بالعربية", en: "Collection Name (Arabic)" },
  COLLECTION_IMAGE: { ar: "صورة المجموعة", en: "Collection Image" },
  NO_COLLECTIONS: { ar: "لا توجد مجموعات", en: "No Collections" },
  ADD_NEW_SUBCATEGORY: { ar: "إضافة فئة فرعية جديدة", en: "Add New SubCategory" },
  EDIT_SUBCATEGORY: { ar: "تعديل الفئة الفرعية", en: "Edit SubCategory" },
  SUBCATEGORY_NAME_EN: { ar: "اسم الفئة الفرعية بالإنجليزية", en: "SubCategory Name (English)" },
  SUBCATEGORY_NAME_AR: { ar: "اسم الفئة الفرعية بالعربية", en: "SubCategory Name (Arabic)" },
  MAIN_CATEGORY: { ar: "الفئة الرئيسية", en: "Main Category" },
  SELECT_CATEGORY: { ar: "اختر الفئة", en: "Select Category" },
  NO_SUBCATEGORIES: { ar: "لا توجد فئات فرعية", en: "No SubCategories" },
  // في ملف words.js
  CATALOG_MANAGEMENT: {
    ar: "إدارة الكتالوج",
    en: "Catalog Management"
  },
  CATALOG_MANAGEMENT_DESC: {
    ar: "إدارة المجموعات والفئات والماركات",
    en: "Manage collections, categories, and brands"
  },
  COLLECTIONS: {
    ar: "المجموعات",
    en: "Collections"
  },
  SUBCATEGORIES: {
    ar: "الفئات الفرعية",
    en: "SubCategories"
  },
  BRANDS: {
    ar: "الماركات",
    en: "Brands"
  },
  PRODUCT_CREATED_SUCCESS: {
    en: 'Product created successfully! You can now add variants or finish.',
    ar: 'تم إنشاء المنتج بنجاح! يمكنك الآن إضافة متغيرات أو إنهاء.'
  },
  ADD_VARIANTS: {
    en: 'Add Variants',
    ar: 'إضافة متغيرات'
  },
  FINISH: {
    en: 'Finish',
    ar: 'إنهاء'
  },
  ADD_ANOTHER_PRODUCT: {
    en: 'Add Another Product',
    ar: 'إضافة منتج آخر'
  },
  STEP: {
    en: 'Step',
    ar: 'خطوة'
  },
  OF: {
    en: 'of',
    ar: 'من'
  },
  CREATE_PRODUCT: {
    en: 'Create Product',
    ar: 'إنشاء المنتج'
  },
  PRODUCT_ID: {
    en: 'Product ID',
    ar: 'معرف المنتج'
  },
  ACCESS_REQUEST: {
    en: "Access Request",
    ar: "طلب إذن دخول"
  },
  ACCESS_REQUEST_DESC: {
    en: "You need to request access to use Addmix dashboard",
    ar: "تحتاج إلى طلب إذن دخول لاستخدام لوحة تحكم أددميكس"
  },
  REQUEST_ACCESS: {
    en: "Request Access",
    ar: "طلب إذن دخول"
  },
  SEND_REQUEST_ACCESS: {
    en: "Send Request",
    ar: "إرسال طلب"
  },
  ENTER_OTP: {
    en: "Enter OTP Code",
    ar: "أدخل كود التحقق"
  },
  OTP_SENT: {
    en: "We sent a 6-digit code to Omar/Marwan",
    ar: "لقد أرسلنا رمز مكون من 6 أرقام إلى عمر/مروان"
  },
  VERIFY: {
    en: "Verify",
    ar: "تحقق"
  },
  RESEND_OTP: {
    en: "Resend OTP",
    ar: "إعادة إرسال الرمز"
  },
  OFF: {
    ar: "خصم",
    en: "off",
    tu: "indirim",
    ru: "скидка",
    fr: "de réduction",
  },
  OPTIONAL: {
    ar: "اختياري",
    en: "Optional",
    tu: "İsteğe Bağlı",
    ru: "Необязательно",
    fr: "Optionnel",
  },
  
  START_DATE: {
    ar: "تاريخ البدء",
    en: "Start Date",
    tu: "Başlangıç Tarihi",
    ru: "Дата начала",
    fr: "Date de début",
  },
  
  PRICE_START_DATE_HINT: {
    ar: "متى يصبح هذا السعر فعالاً (اختياري)",
    en: "When this price becomes active (optional)",
    tu: "Bu fiyatın ne zaman aktif olacağı (isteğe bağlı)",
    ru: "Когда эта цена становится активной (необязательно)",
    fr: "Quand ce prix devient actif (optionnel)",
  },
  
  END_DATE: {
    ar: "تاريخ الانتهاء",
    en: "End Date",
    tu: "Bitiş Tarihi",
    ru: "Дата окончания",
    fr: "Date de fin",
  },
  
  PRICE_END_DATE_HINT: {
    ar: "متى تنتهي صلاحية هذا السعر (اختياري)",
    en: "When this price expires (optional)",
    tu: "Bu fiyatın ne zaman sona ereceği (isteğe bağlı)",
    ru: "Когда срок действия этой цены истекает (необязательно)",
    fr: "Quand ce prix expire (optionnel)",
  },
    DESELECT_ALL: {
    ar: "إلغاء تحديد الكل",
    en: "Deselect All",
    tu: "Tümünü Kaldır",
    ru: "Снять все выделения",
    fr: "Tout désélectionner",
  },
  
  SELECT_ALL: {
    ar: "تحديد الكل",
    en: "Select All",
    tu: "Tümünü Seç",
    ru: "Выбрать все",
    fr: "Tout sélectionner",
  },
  
  NO_COLOR: {
    ar: "بدون لون",
    en: "No Color",
    tu: "Renk Yok",
    ru: "Без цвета",
    fr: "Pas de couleur",
  },
  
  NEW_PRICE_INFORMATION: {
    ar: "معلومات السعر الجديدة",
    en: "New Price Information",
    tu: "Yeni Fiyat Bilgisi",
    ru: "Новая информация о ценах",
    fr: "Nouvelles informations sur les prix",
  },
  
  REGULAR_PRICE: {
    ar: "السعر العادي",
    en: "Regular Price",
    tu: "Normal Fiyat",
    ru: "Обычная цена",
    fr: "Prix normal",
  },
  
  LEAVE_EMPTY_TO_KEEP_CURRENT: {
    ar: "اتركه فارغاً للحفاظ على السعر الحالي",
    en: "Leave empty to keep current",
    tu: "Mevcut değeri korumak için boş bırakın",
    ru: "Оставьте пустым, чтобы сохранить текущее",
    fr: "Laissez vide pour conserver l'actuel",
  },
    UPDATE_ALL_VARIANTS: {
    ar: "تحديث جميع المتغيرات",
    en: "Update All Variants",
    tu: "Tüm Varyantları Güncelle",
    ru: "Обновить все варианты",
    fr: "Mettre à jour toutes les variantes",
  },
  
  UPDATE_SELECTED_VARIANTS: {
    ar: "تحديث المتغيرات المختارة",
    en: "Update Selected Variants",
    tu: "Seçili Varyantları Güncelle",
    ru: "Обновить выбранные варианты",
    fr: "Mettre à jour les variantes sélectionnées",
  },
  
  SELECT_VARIANTS: {
    ar: "اختر المتغيرات",
    en: "Select Variants",
    tu: "Varyantları Seç",
    ru: "Выбрать варианты",
    fr: "Sélectionner les variantes",
  },

    SELECT_AT_LEAST_ONE_VARIANT: {
    ar: "يرجى اختيار متغير واحد على الأقل",
    en: "Please select at least one variant",
    tu: "Lütfen en az bir varyant seçin",
    ru: "Пожалуйста, выберите хотя бы один вариант",
    fr: "Veuillez sélectionner au moins une variante",
  },
  
  UPDATE_FAILED: {
    ar: "فشل تحديث الأسعار",
    en: "Failed to update prices",
    tu: "Fiyatlar güncellenemedi",
    ru: "Не удалось обновить цены",
    fr: "Échec de la mise à jour des prix",
  },
    ADD_COLOR: {
    ar: "إضافة لون",
    en: "Add Color",
  },
  ADD_SIZE: {
    ar: "إضافة مقاس",
    en: "Add Size",
  },
  EDIT_COLOR: {
    ar: "تعديل اللون",
    en: "Edit Color",
  },
  EDIT_SIZE: {
    ar: "تعديل المقاس",
    en: "Edit Size",
  },
  ENGLISH_NAME: {
    ar: "الاسم بالإنجليزية",
    en: "English Name",
  },
  ARABIC_NAME: {
    ar: "الاسم بالعربية",
    en: "Arabic Name",
  },
  HEX_CODE: {
    ar: "كود اللون",
    en: "Hex Code",
  },
  SIZE_TYPE: {
    ar: "نوع المقاس",
    en: "Size Type",
  },
  DELETE_CONFIRMATION: {
    ar: "هل أنت متأكد من حذف هذا العنصر؟",
    en: "Are you sure you want to delete this item?",
  },
  NO_COLORS_FOUND: {
    ar: "لا توجد ألوان",
    en: "No colors found",
  },
  NO_SIZES_FOUND: {
    ar: "لا توجد مقاسات",
    en: "No sizes found",
  },
  CLOTHING: {
    ar: "ملابس",
    en: "Clothing",
  },
  SHOES: {
    ar: "أحذية",
    en: "Shoes",
  },
  ACCESSORIES: {
    ar: "إكسسوارات",
    en: "Accessories",
  },
  ITEM_CREATED_SUCCESS: {
    ar: "تم إنشاء العنصر بنجاح",
    en: "Item created successfully",
  },
  ITEM_UPDATED_SUCCESS: {
    ar: "تم تحديث العنصر بنجاح",
    en: "Item updated successfully",
  },
  ITEM_DELETED_SUCCESS: {
    ar: "تم حذف العنصر بنجاح",
    en: "Item deleted successfully",
  },
  STATUS_UPDATED_SUCCESS: {
    ar: "تم تحديث الحالة بنجاح",
    en: "Status updated successfully",
  },
  UPDATE_QUANTITIES: {
    en: 'Update Quantities',
    ar: 'تحديث الكميات'
},
NEW_QUANTITY_INFORMATION: {
    en: 'New Quantity Information',
    ar: 'معلومات الكمية الجديدة'
},
QUANTITY: {
    en: 'Quantity',
    ar: 'الكمية'
},
ENTER_QUANTITY: {
    en: 'Enter quantity',
    ar: 'أدخل الكمية'
},
WITHOUT_BOX: {
    en: 'Without Box',
    ar: 'بدون علبة'
},
QUANTITY_TYPE: {
    en: 'Quantity Type',
    ar: 'نوع الكمية'
},
NEW_QUANTITY: {
    en: 'New Quantity',
    ar: 'الكمية الجديدة'
},
VARIANTS_TO_UPDATE: {
    en: 'Variants to Update',
    ar: 'المتغيرات المراد تحديثها'
},
UPDATE_PREVIEW: {
    en: 'Update Preview',
    ar: 'معاينة التحديث'
}

};

export default words;
